"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOAuth = void 0;
const react_1 = require("react");
const TokenContext_1 = require("../contexts/TokenContext");
function useOAuth() {
    return react_1.useContext(TokenContext_1.TokenContext);
}
exports.useOAuth = useOAuth;
//# sourceMappingURL=useOAuth.js.map